module.exports = __webpack_public_path__ + "images/patterns/light/Scale.3ce802953f7ad2707ebd.svg";